<template>
  <div v-if="!load">
    <div style="position: absolute;width: 100%; height: 100%;background: #f9f9f9;" v-if="order.payMethod != 'UNIONPAY_WX' || order.status != 'SUCCESS' || !isWeixin"> 
        <div class="head_box">
          <div style="padding-top: 40px;">
            <van-icon name="passed" v-if="order.status == 'SUCCESS'" />
            <van-icon name="close" v-else />
          </div>
          <div style="font-size: 0.23rem;" v-if="order.status == 'SUCCESS'">缴费成功</div>
          <div style="font-size: 0.23rem;" v-if="order.status == 'PAYING'">暂未支付</div>
          <div style="font-size: 0.23rem;" v-if="order.status == 'CLOSED'">订单关闭</div>
          </div>
        <div class="content">
          <div style="font-size: 0.5rem;margin-bottom: 20px;">
            <span style="font-size: 0.25rem;">￥</span>
            <span style="font-size: 0.5rem;">{{order.totalAmount}}</span>
            </div>
          <div class="conent-item">缴费用户：{{order.consName}}</div>
          <div class="conent-item">创建时间：{{order.createTime}}</div>
          <div class="conent-item">缴费方式：{{order.payMethod == "UNIONPAY_WX" ? "微信支付" : order.payMethod == "UNIONPAY_ALI" ? "支付宝支付" :  order.payMethod == "UNIONPAY_UAC" ? "云闪付支付" : ""}}</div>
        </div>

        <div style="display: flex;justify-content: center;">
          <div class="return_home_btn" @click="returnHome">返回首页</div>
        </div>
    </div>
    <div v-else>
      <div style="color: #07c160;">
        <div style="padding-top: 20px;">
          <van-icon name="passed" v-if="order.status == 'SUCCESS'" />
          <van-icon name="close" v-else />
        </div>
        <div style="font-size: 0.23rem;" v-if="order.status == 'SUCCESS'">缴费成功</div>
        <div style="font-size: 0.23rem;" v-if="order.status == 'PAYING'">暂未支付</div>
        <div style="font-size: 0.23rem;" v-if="order.status == 'CLOSED'">订单关闭</div>
      </div>
      <div style="font-size: .23rem;padding: 5% 0;">
        <div style="font-size: 0.5rem;margin-bottom: 20px;">
          <span style="font-size: 0.25rem;">￥</span>
          <span style="font-size: 0.5rem;">{{order.totalAmount}}</span>
          </div>
        <div class="conent-item">缴费用户：{{order.consName}}</div>
        <div class="conent-item">创建时间：{{order.createTime}}</div>
        <div class="conent-item">缴费方式：{{order.payMethod == "UNIONPAY_WX" ? "微信支付" : order.payMethod == "UNIONPAY_ALI" ? "支付宝支付" :  order.payMethod == "UNIONPAY_UAC" ? "云闪付支付" : ""}}</div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" charset="UTF-8" src="https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js"></script>
<script>
  window.onload = function () {
        var mchData = {action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE'}
        var postData = JSON.stringify(mchData)
        parent.postMessage(postData, 'https://payapp.weixin.qq.com')
    }

import { queryOrderDetail } from "@/api/user.js";
import Vue from "vue";
import { Notify, DatetimePicker, Popup, Toast } from "vant";
Vue.use(Notify);
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
  data() {
    return {
      order:{orderId: ""},
      load: true,
      isWeixin: false,
    };
  },
  created() {
    this.order.orderId = this.$route.query.orderId;
    this.queryOrderDetail();

    let ua = navigator.userAgent;
    this.isWeixin = ua.indexOf("MicroMessenger") > 0; 
  },
  methods: {
    queryOrderDetail() {
      queryOrderDetail(this.order.orderId).then(res => {
          this.load = false;
          if (res.data.status == 200) {
            this.order = res.data.object;
          } else {
            this.bill = null;
          }
      });
    },
    returnHome() {
      this.$router.push({
        path: "/tcmr/home"
      });
    }
  }
};
</script>


<style  scoped>
.head_box {
  height: 3.5rem;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 6.4rem auto;
  background: url("../assets/myTopBG.png");
  color: white;
}

.content {
  background: white;
  position: relative;
  top: -50px;
  width: 80%;
  margin-left: 10%;
  font-size: 0.23rem;
  border-radius: 5px;
  padding: 5% 0;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}

.conent-item {
  text-align: left;
  line-height: 0.4rem;
  margin-left: 5%;
  margin-right: 5%;
}

.return_home_btn {
  color: #50c7a1;
  width: 160px;
  font-size: 00.2rem;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  border: 1px solid #50c7a1;
  border-radius: 0.06rem;
}
</style>